import { useAuth } from '../AuthModule';
import ProfileNavTopBar from '../ProfileNavTopBar';

export default function TyokalutPage() {
  const { user } = useAuth();
  const isAdmin = !!user && user.role === 'admin';

  if (!user) {
    return (
      <div className="App-block">
          <p>Kirjaudu sisään nähdäksesi hallintatyökalut.</p>
      </div>
    );
  }

  return (
    <div className="App-block">
      <ProfileNavTopBar user={user} currentPage="admin" />

      <p>Täällä voit käyttää ylläpidon työkaluja.</p>

      {isAdmin ? (
        <div className="Tyokalut-admin-links">
          <p>
            <a className="Tyokalut-admin-link" href="/admin/paivan-kysymys">
              Luo päivän kysymys
            </a>
          </p>
          <p>
            <a className="Tyokalut-admin-link" href="/admin/tarkasta-ehdotukset">
              Tarkasta kaikki ehdotukset</a>
          </p>
          <p>
            <a className="Tyokalut-admin-link" href="/admin/lahjoita-krediitteja">
              Lahjoita krediittejä
            </a>
          </p>
          <p>
            <a className="Tyokalut-admin-link" href="/admin/beta-testaajat">
              Hyväksy beta-testaajia
            </a>
          </p>
        </div>
      ) : null}
    </div>
  );
}
